/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

module.exports = require('dispatchr/addons/createStore');



//////////////////
// WEBPACK FOOTER
// ./~/fluxible/addons/createStore.js
// module id = 18
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 12 15 16 17 20 21